import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .crisp-client {
    display: none !important;
  }
`

export const Container = styled.form`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: var(--safe-area-inset-top, 0px);
`

export const HeaderContainer = styled.header`
  width: 100%;
  height: 72px;
  border-bottom: 1px solid var(--border-neutral-faded, #dfe2ea);
  padding: 16px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

export const PreviousButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 8px;
  box-sizing: border-box;

  cursor: pointer;

  svg {
    fill: var(--foreground-neutral, #14171f);
  }
`

export const CloseButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;
  min-width: 36px;
  padding: 8px;
  box-sizing: border-box;

  cursor: pointer;

  svg {
    fill: var(--foreground-neutral, #14171f);
    transform: rotate(45deg);
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  flex: 1;
`

export const Title = styled.h1`
  margin: 0px;

  color: var(--foreground-neutral, #14171f);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  white-space: nowrap;
  overflow: hidden; /* Ajoutez cette ligne */
  text-overflow: ellipsis;
  width: 100%;
`

export const SubmitButton = styled.button`
  border: none;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 48px;
  width: 100%;

  padding: 16px;
  margin: 16px;

  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    var(--Foreground-Secondary, #2fb609);
  background-blend-mode: soft-light, normal;

  /* Raised */
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  color: var(--Persistent-White, #fff);

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  cursor: pointer;
`

export const ScrollContainer = styled.div<{ open?: boolean }>`
  width: 100%;
  flex: 1;

  overflow-y: ${({ open }) => (open ? 'auto' : 'none')};

  padding-bottom: calc(var(--safe-area-inset-top, 0px) + var(--safe-area-inset-bottom, 0px));
`

export const MainContainer = styled.main<{ fullScreen?: boolean }>`
  min-height: 100%;

  margin: 0 auto;
  width: 100%;
  max-width: ${({ fullScreen }) => (fullScreen ? '100%' : '720px')};

  display: flex;
`

export const FooterContainer = styled.header`
  border-top: 1px solid var(--border-neutral-faded, #dfe2ea);
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;

  min-height: calc(80px + var(--safe-area-inset-bottom, 0px));

  padding-bottom: calc(var(--safe-area-inset-top, 0px) + var(--safe-area-inset-bottom, 0px));
  padding-left: var(--safe-area-inset-left, 0px);
  padding-right: var(--safe-area-inset-right, 0px);
`
